// src/components/UserForm.jsx

import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../Common/ActionButton';
import './UserForm.css';
import { useTranslation } from 'react-i18next'; // Import the i18n hook
import { useLanguageSettings } from '../Common/LanguageSettingsContext'; // Import LanguageSettings hook
import { useColorSettings } from '../Common/ColorSettingsContext'; // Import ColorSettings hook
import Spinner from '../Common/Spinner'; // Import Spinner component

const UserForm = ({
  fullName,
  setFullName,
  email,
  setEmail,
  role,
  setRole,
  isMobile,
  onSubmit,
  isEditing,
}) => {
  const { t } = useTranslation(); // Initialize the i18n translation hook

  // Consume LanguageSettings and ColorSettings contexts
  const { language, updateLanguage, loading: languageLoading } = useLanguageSettings();
  const { appSettings, loading: colorLoading } = useColorSettings();

  // Combine loading states
  if (colorLoading || languageLoading) {
    return (
      <div className="users-modal-form">
        <Spinner />
      </div>
    );
  }

  return (
    <form className="users-modal-form" onSubmit={onSubmit}>
      <div className="users-input-group">
        <label htmlFor="fullName">{t('userForm.fullNameLabel')}:</label>
        <input
          type="text"
          id="fullName"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
          aria-required="true"
        />
      </div>
      <div className="users-input-group">
        <label htmlFor="email">{t('userForm.emailLabel')}:</label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isEditing}
          style={isEditing ? { backgroundColor: '#e9ecef' } : {}}
          aria-required="true"
          aria-label={t('userForm.emailLabel')}
        />
      </div>
      <div className="users-input-group">
        <label htmlFor="role">{t('userForm.roleLabel')}:</label>
        <select
          id="role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
          aria-required="true"
          aria-label={t('userForm.roleLabel')}
        >
          <option value="user">{t('userForm.userOption')}</option>
          <option value="admin">{t('userForm.adminOption')}</option>
        </select>
      </div>
      {/* Container to center the Save/Update button */}
      <div className="users-submit-button-container">
        <ActionButton
          type="submit"
          label={isEditing ? t('userForm.updateButton') : t('userForm.saveButton')}
          text={isEditing ? t('userForm.updateButton') : t('userForm.saveButton')}
          icon="faSave"
          isMobile={isMobile}
          colorType="primary"
          ariaLabel={isEditing ? t('userForm.updateButtonAria') : t('userForm.saveButtonAria')}
        />
      </div>
    </form>
  );
};

UserForm.propTypes = {
  fullName: PropTypes.string.isRequired,
  setFullName: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  setEmail: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  setRole: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export default UserForm;
